import { l } from '@manychat/manyui'

import { alert } from 'common/core'
import { getNewEventObject } from 'common/events/selectors/eventSelectors'
import { formatEntitiesListResponse } from 'common/usesList/utils'
import * as API from 'constants/API'
import { makeLimitedListActions } from 'utils/factory'
import { getPageId } from 'utils/router/tools'
import { anotherTabNotificationsListener } from 'utils/services/notificationsService'

import * as atypes from '../eventsReduxActionTypes'

const baseListActions = makeLimitedListActions('customEvents')

export const fetchCustomEvents = (includeArchived) => baseListActions.fetch() //{ active_only: !includeArchived }

export const eventCreatedNotification = baseListActions.createdNotification
export const eventUpdatedNotification = baseListActions.updatedNotification
export const eventDeletedNotification = baseListActions.deletedNotification

let newCustomEventPromise
const rechargeNewCustomEventPromise = () =>
  new Promise((resolve, reject) => (newCustomEventPromise = { resolve, reject }))
newCustomEventPromise = rechargeNewCustomEventPromise()

export const openCustomEventModal = (initialData) => {
  return (dispatch) => {
    dispatch({ type: atypes.EVENTS_OPEN_CREATE_MODAL, initialData })

    return rechargeNewCustomEventPromise()
  }
}
export const closeCustomEventModalChange = () => ({
  type: atypes.EVENTS_CLOSE_CREATE_MODAL,
  initialData: {},
})

export const createCustomEventModalChange = (data) => {
  return {
    type: atypes.EVENTS_CREATE_MODAL_CHANGE,
    data,
  }
}

export const createEvent = () => {
  return async (dispatch, getState) => {
    const data = getNewEventObject(getState())

    try {
      const val = await dispatch(baseListActions.create({ ...data }))

      alert(l.translate('Event Created!'), 'success')

      newCustomEventPromise.resolve(val.item)

      dispatch(closeCustomEventModalChange())
    } catch (err) {
      newCustomEventPromise.reject(err)
    }
  }
}

export const updateEvent = (payload) => {
  return (dispatch) => {
    dispatch(baseListActions.update(payload.event_id, payload))
  }
}

export const archiveEvent = (event_id) => {
  return (dispatch, getState) => {
    dispatch(baseListActions.archive(event_id, { event_id }))
  }
}

export const getEntitiesList = (event_id) => {
  return async (dispatch) => {
    // eslint-disable-next-line
    try {
      const pageId = getPageId()
      const response = await dispatch({
        type: atypes.EVENTS_GET_ENTITIES_LIST,
        $endpoint: ['events.getUsesList', { pageId, event_id }],
      })

      return formatEntitiesListResponse(response, pageId)
    } catch (e) {
      throw e
    }
  }
}

export const getAvailableCurrenciesList = () => ({
  type: atypes.EVENTS_GET_AVAILABLE_CURRENCIES,
  $fetch: [API.events.endpoints.getAvailableCurrenciesList],
})

anotherTabNotificationsListener.on('custom_event_created', (data, dispatch) => {
  dispatch(eventCreatedNotification(data.model))
})

anotherTabNotificationsListener.on('custom_event_updated', (data, dispatch) => {
  dispatch(eventUpdatedNotification(data.model))
})
